import { useState } from 'react';
import { MessageType } from '../core/localization';
import { CallStatus } from '../models';
import { CallStatusDefault } from '../models/default';
import { fetch, success, error } from '../utils/callStatus';

export interface UseCallStatusData {
  status: CallStatus;
}

export const UseCallStatusDataDefault: UseCallStatusData = {
  status: CallStatusDefault,
};

export interface UseCallStatusResult extends UseCallStatusData {
  reset: (status?: CallStatus) => void;
  fetch: () => void;
  success: () => void;
  error: (err: MessageType) => void;
}
const useCallStatus = (initialState = UseCallStatusDataDefault): UseCallStatusResult => {
  const [status, setStatus] = useState(initialState.status);

  return {
    status,
    reset: (status = CallStatusDefault) => setStatus(status),
    fetch: () => setStatus(fetch(status)),
    success: () => setStatus(success(status)),
    error: (err: MessageType) => setStatus(error(status, err)),
  };
};

export default useCallStatus;
